import { ReferenceDataOptionLists } from '../../../lib/constants/reference-data-option-lists';
import { Deserializable } from '../../../lib/models/deserializable';
import { Product } from './../../../lib/models/api/product.model';

export class CaseProduct implements Deserializable {
  public CaseProductID: number;
  public ProductID?: number;
  public ProductOrder?: number;
  public LoanAmount?: number;
  public LoanTermYears?: number;
  public LoanTermMonths?: number;
  public RepaymentTypeCode: string;
  public Identifier?: string;
  public Product: Product;

  deserialize(input: any): this {
    Object.assign(this, input);
    if (input.Product) {
      this.Product = new Product().deserialize(input.Product);
    }

    return this;
  }

  isRepaymentOrNotSure(): boolean {
    return (
      this.RepaymentTypeCode === ReferenceDataOptionLists.RepaymentTypeFFRepayment ||
      this.RepaymentTypeCode === ReferenceDataOptionLists.RepaymentTypeFFNotSure
    );
  }
}
